import { useDispatch, useSelector } from "react-redux";
import Alert from "react-bootstrap/Alert";
import { Link } from "react-router-dom";
import { setSettings } from "../store/settings";
import styles from "../styles/AlertDismissable.module.scss";
import { useState } from "react";

const AlertDismissible = () => {
  const dispatch = useDispatch();
  const seenAlert = useSelector((state) => state.settings.alerts?.april2023);
  const [show, setShow] = useState(!seenAlert);

  const onClose = () => {
    setShow(false);
    dispatch(setSettings({ alerts: { april2023: true } }));
  };

  return (
    <div className={styles.container}>
      <Alert dismissible onClose={onClose} show={show} variant="info">
        {"EDHREChat bot is now live! "}
        <Link to="/chat">Get deck help now.</Link>
      </Alert>
    </div>
  );
};

export default AlertDismissible;
